var _effectorFileName = "/src/shared/components/marquee/marquee.tsx";
import { cn } from '@/shared/lib/cn';
interface MarqueeProps {
  className?: string;
  reverse?: boolean;
  pauseOnHover?: boolean;
  children?: React.ReactNode;
  vertical?: boolean;
  repeat?: number;
}
export const Marquee = (props: MarqueeProps) => {
  const {
    className,
    reverse,
    pauseOnHover = false,
    repeat = 8,
    vertical = false,
    children
  } = props;
  return <div {...props} className={cn('group flex overflow-hidden p-2 [--duration:40s] [--gap:1rem] [gap:var(--gap)]', {
    'flex-row': !vertical,
    'flex-col': vertical
  }, className)}>
      {Array(repeat).fill(0).map((_, i) => <div key={i} className={cn(`flex shrink-0 justify-around [gap:var(--gap)]`, {
      'animate-marquee flex-row': !vertical,
      'animate-marquee-vertical flex-col': vertical,
      'group-hover:[animation-play-state:paused]': pauseOnHover,
      '[animation-direction:reverse]': reverse
    })}>
            {children}
          </div>)}
    </div>;
};